<template>
  <div class="app-download-page">
    <p v-if="status === 'loading'" class="message">正在获取下载页面…</p>
    <p v-else-if="status === 'redirecting'" class="message">正在前往下载页面…</p>
    <p v-else-if="status === 'invalid'" class="message">下载链接配置无效，请联系客服。</p>
    <p v-else class="message">暂未配置app下载落地页，请联系客服。</p>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      status: 'loading',
      unavailableTimer: null
    };
  },
  computed: {
    appDownloadLandingUrl() {
      return (this.$store.state.appInfo || {}).app_download_landing_url || '';
    }
  },
  watch: {
    appDownloadLandingUrl: {
      immediate: true,
      handler(url) {
        if (url) this.redirectToLandingPage(url);
      }
    }
  },
  mounted() {
    this.unavailableTimer = window.setTimeout(() => {
      if (this.status === 'loading') this.status = 'unavailable';
    }, 3000);
  },
  beforeDestroy() {
    window.clearTimeout(this.unavailableTimer);
  },
  methods: {
    redirectToLandingPage(url) {
      let target;
      try {
        target = new URL(url, window.location.href);
      } catch (error) {
        this.status = 'invalid';
        return;
      }

      if (!['http:', 'https:'].includes(target.protocol)) {
        this.status = 'invalid';
        return;
      }

      window.clearTimeout(this.unavailableTimer);
      this.status = 'redirecting';
      window.location.replace(target.href);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-download-page {
  display: flex;
  min-height: 55vh;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #666;
}

.message {
  text-align: center;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/app.vue